import React, {FC, memo, useEffect, useState} from "react";
import ContextMenu from "../ContextMenu/ContextMenu";
import {CardContainer, CardContext, CardContextImg, CardText} from "./CardStyle";
import {useDispatch} from "react-redux";
import {AppDispatch} from "../../store/configureStore";
import {actions, ICardModel} from "../../store/sliceModal";
import {actions as actionsFiles} from "../../store/sliceFiles";
import FileCheckbox from "../FileCheckbox/FileCheckbox";
import {config} from "../../config";
import {useNavigate} from "react-router-dom";

import questionImg from "../../image/question.png"
import {CardProps} from "./CardDefault";
import {maxContent} from "../../utils/Util";


const CardImg: FC<CardProps> = (props) => {

    const {file, checkMode, publicPath} = props

    const dispatch = useDispatch<AppDispatch>();
    const nav = useNavigate();

    const [checked, setChecked] = useState(false)
    const [img, setImg] = useState('')

    useEffect(() => {
        if (file && ['png', 'jpg', 'jpeg', 'gif'].includes(file?.type)) {
            if (publicPath?.length != null) {
                setImg(`${config.baseurl}/api/public/file/img/${publicPath}/${file?.icon}`)
            } else {
                setImg(`${config.baseurl}/api/img/${file?.icon}`)
            }
        } else {
            setImg(questionImg)
        }

    }, [file])

    useEffect(() => {
        setChecked(false);
    }, [checkMode])


    const showModal = (event: React.MouseEvent<HTMLElement> | React.TouchEvent<HTMLElement>) => {

        if (!checkMode) {
            dispatch(actions.showCard({
                name:  `${file?.name}.${file?.type}`,
                id: file?.id,
                image: img,
                publicPath: publicPath
            } as ICardModel))
        } else {
            if (checked) {
                dispatch(actionsFiles.removeChecked(file?.id!!))
                setChecked(false)
            } else {
                dispatch(actionsFiles.addChecked(file?.id!!))
                setChecked(true)
            }
        }
    }

    return (
        <CardContainer cheked={!!checkMode}
            onClick={showModal}
        >
            <CardContext>
                <ContextMenu file={file} isPublic={publicPath?.length != null}>
                    <CardContextImg image={img}>
                        {checkMode &&
                            <FileCheckbox cheked={checked}/>
                        }
                    </CardContextImg>

                </ContextMenu>
            </CardContext>
            <CardText>{`${maxContent(file?.name)}.${file?.type}`}</CardText>
        </CardContainer>
    )

}

export default memo(CardImg)
